//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import BaseCmsBlock from "../../node_modules/sitis-nuxt/lib/cms/CmsBlockMixin";
import Breadcrumbs from "~/components/page/PageBreadcrumbs.vue";
import {scrollToElement} from "~/helpers/scrollToElement";

export default BaseCmsBlock.extend({

  data: function () {
    return {

      openedTags: [],
      openedItems: [],

      illuminatedItemId: null,

      search: ""
    }
  },

  computed: {
    items: function () {
      const extrasItems = this.extras?.items || [];

      if (String(this.search || '').length <= 2) {
        return [...(this.extras?.tags || [])]
          .map((_t) => {
            return {
              ..._t,
              items: [...(extrasItems || [])].filter((t) => Boolean(String(t.tag_id) === String(_t.id)))
            }
          })
          .filter((_t) => Boolean(_t.items.length > 0))
      }

      const _search = String(this.search || '').toLowerCase();
      const _extrasItems = [...(extrasItems)].filter((t) => {
        const _answer = String(t?.answer || "").toLowerCase();
        const _question = String(t?.question || "").toLowerCase();

        return Boolean(
          _answer.includes(_search) ||
          _question.includes(_search)
        )
      });
      return [...(this.extras?.tags || [])]
        .map((_t) => {
          return {
            ..._t,
            items: [...(_extrasItems || [])].filter((t) => Boolean(String(t.tag_id) === String(_t.id)))
          }
        })
        .filter((_t) => Boolean(_t.items.length > 0))
    },
    breadcrumbs: function () {
      return [
        {path: "/", title: this.$t("breadcrumbs.homePage")},
        {path: this.$route.path, title: "FAQ"},
      ]
    },

    isHome: function () {
      return Boolean(this.$route.fullPath === '/' || this.$route.fullPath === '/ru');
    }
  },

  components: {
    Breadcrumbs
  },

  mounted: function () {
    this.checkHash();
  },

  methods: {
    checkHash: function () {
      const hash = window.location?.hash;
      if (!hash) {
        return
      }

      const itemId = String(hash || "").replace("#", "");
      if (!itemId) {
        return;
      }

      const extrasItems = this.extras?.items || [];
      const item = extrasItems.find((t) => Boolean(String(t.id) === String(itemId)));
      if (!item) {
        return;
      }

      this.openedTags = [Number.parseFloat((item.tag_id))];
      this.openedItems = [Number.parseFloat(item.id)];

      setTimeout(() => {
        scrollToElement(`[data-faq-id="${ item.id }"]`);
        this.illuminatedItemId = item.id;
        setTimeout(() => {
          this.illuminatedItemId = null;
        }, 3000)
      }, 500)
    },

    changeOpenedTags: function (id) {
      let _opened = [...this.openedTags];
      let _index = _opened.findIndex((t) => Boolean(String(t) === String(id)));
      if (_index > -1) {
        _opened.splice(_index, 1)
      } else {
        _opened.push(id)
      }
      this.openedTags = _opened;
    },
    changeOpenedItems: function (id) {
      let _opened = [...this.openedItems];
      let _index = _opened.findIndex((t) => Boolean(String(t) === String(id)));
      if (_index > -1) {
        _opened.splice(_index, 1)
      } else {
        _opened.push(id)
      }
      this.openedItems = _opened;

      if (_index === -1) {
        window.history.replaceState(null, null, [window.location?.pathname, id].join('#'))
      }
    },

    changeOpened: function (id) {
      let _opened = [...this.opened];
      let _index = _opened.findIndex((t) => t === id);
      if (_index > -1) {
        _opened.splice(_index, 1)
      } else {
        _opened.push(id)
      }
      ;
      this.opened = _opened;
    },
  }

});
